// js/components/ModalManager.js
import { Accessibility, Listeners } from '../utils.js';

class CosModalManager extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.activeListeners = new Listeners();

    this._attachListeners();
  }

  _attachListeners() {
    const triggerButton = this.querySelector('[data-action="open-modal"]');
    if (!triggerButton) return;
    this.listeners.add(triggerButton, 'click', () => this._openModal());
  }

  _openModal() {
    document.dispatchEvent(new CustomEvent("modal:close"));

    const button = this.querySelector('[data-action="open-modal"]');
    if (!button) return;
    
    this.modal = document.querySelector(`#${button.getAttribute("aria-controls")}`);
    if (!this.modal) return;

    if (this.modal.tagName === "DIALOG") {
      this.modal.showModal();
      this.modal.setAttribute("aria-hidden", "false");
    } else {
      const onOpen = (event2) => {
        if (event2.propertyName === "visibility") {
          this.modal.removeEventListener("transitionend", onOpen);
          Accessibility.trapFocus(this.modal, "modal" + this.modal.id);
        }
      };
      this.modal.addEventListener("transitionend", onOpen);
      this.modal.setAttribute("aria-hidden", "false");
    }
    document.documentElement.classList.add("is-locked");
    
    // Creează overlay-ul pentru modal (înlocuiește .modal:before)
    this.modalOverlay = document.createElement('div');
    this.modalOverlay.className = 'modal-overlay';
    this.modalOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #1668A24D;
      pointer-events: auto;
    `;
    this.modal.prepend(this.modalOverlay);
    
    this.activeListeners.add(document, 'modal:close', () => this._closeModal());
    this.activeListeners.add(this.modalOverlay, 'click', () => this._closeModal());
    // this.activeListeners.add(document, 'click', (event) => {
    //   if (!this.modal) return;

    //   const modalDialog = this.modal.querySelector('.modal__dialog');
    //   if (!modalDialog) return;

    //   if (!modalDialog.contains(event.target) || modalDialog !== event.target) {
    //     // this._closeModal(event);
    //   }
    // });
    this.activeListeners.add(document, 'keyup', (event) => {
      if (event.key === "Escape") {
        this._closeModal();
      }
    });

    const closeButton = this.modal.querySelectorAll('[data-action="close-modal"]');
    closeButton.forEach((button) => {
      this.activeListeners.add(button, 'click', () => this._closeModal());
    });
  }

  _closeModal() {
    if (this.modal.tagName === "DIALOG") {
      this.modal.close();
      this.modal.setAttribute("aria-hidden", "true");
    } else {
      const onClose = (event2) => {
        if (event2.propertyName === "visibility") {
          this.modal.removeEventListener("transitionend", onClose);
          Accessibility.removeTrapFocus(this.modal, "modal" + this.modal.id);
          this.modal.dispatchEvent(new CustomEvent("modal:closed"));
        }
      };
      this.modal.addEventListener("transitionend", onClose);
      this.modal.setAttribute("aria-hidden", "true");
    }
    document.documentElement.classList.remove("is-locked");
    
    // Șterge overlay-ul
    if (this.modalOverlay) {
      this.modalOverlay.remove();
      this.modalOverlay = null;
    }
    
    if (this.activeListeners) {
      this.activeListeners.removeAll();
    }
  }

  disconnectedCallback() {
    if (this.activeListeners) {
      this.activeListeners.removeAll();
    }
    if (this.listeners) {
      this.listeners.removeAll();
    }
    
    // Cleanup overlay dacă există
    if (this.modalOverlay) {
      this.modalOverlay.remove();
      this.modalOverlay = null;
    }
  }
}

if (!customElements.get('cos-modal-manager')) customElements.define('cos-modal-manager', CosModalManager);
